import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import CheckoutSection from "../../components/CheckoutSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { connect } from "react-redux";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";

const CheckoutPage = ({ cartList }) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={t(`checkout`)} pagesub={t(`checkout`)} />
      <CheckoutSection cartList={cartList} />
      <Footer ftClass={"s2"} />
      <Scrollbar />
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    cartList: state.cartList.cart,
    symbol: state.data.symbol,
  };
};

export default connect(mapStateToProps)(CheckoutPage);
